import PropTypes from 'prop-types';

/**
 * What every tab of the full unit page receives, as one `ctx` prop:
 *
 *   unit            the inventory row (P-UNIT-026); for a committed unit,
 *                   its committed row with the in-stock-only fields blanked
 *                   (utils/committedUnit)
 *   committed       the unit is committed (sale pending, pre-sold, sold):
 *                   in-stock-only cards say "Not available for committed units"
 *   detail          hooks/useUnitDetail for this unit (shared with the pane)
 *   activities      hooks/useUnitActivities for this unit (one request for
 *                   the hero chip, the tab count and the Activity tab)
 *   allUnits        the loaded inventory (peer context, calibrated risk cuts)
 *   machineCatalog  display names
 *   readOnly        a read-only workspace: no write actions
 *   goTab(id, { anchor })  switch tab (and scroll to an element id)
 *   openLightbox(i) open the photo viewer at photo i
 *   showToast({ text, onUndo })  the page's toast
 *   createNonce     bumps when "Create task" (hero) asks for the create form;
 *                   0 = not asked, or the request was already consumed
 *   onCreateConsumed()  the Activity tab opened the form for the request;
 *                   createNonce goes back to 0 until the next one
 */
export const tabCtxShape = PropTypes.shape({
    unit: PropTypes.object.isRequired,
    committed: PropTypes.bool,
    detail: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    allUnits: PropTypes.array,
    machineCatalog: PropTypes.object,
    readOnly: PropTypes.bool,
    goTab: PropTypes.func.isRequired,
    openLightbox: PropTypes.func.isRequired,
    showToast: PropTypes.func.isRequired,
    createNonce: PropTypes.number,
    onCreateConsumed: PropTypes.func,
});
